import { createReducer, on } from '@ngrx/store';
import { setUserRoleInfo } from '../actions/user-role.actions'; // Adjust the import path as necessary

export interface UserRoleState {
  name: string;
  is_internal: boolean;
}

export const initialState: UserRoleState = {
  name: '',
  is_internal: false,
};

export const userRoleReducer = createReducer(
  initialState,
  on(setUserRoleInfo, (state, { userRole }) => ({
    ...state,
    name: userRole.name,
    is_internal: userRole.is_internal,
  })),
);
